module.exports = __webpack_public_path__ + "static/media/dhjfxf.09518c83.png";